<template>
    <div class="toToBox" id="toToBoxDiv">
        <topImg :imgHeight="imgHeight" :background="background" :showInput="false"></topImg>
        <onlyContent></onlyContent>
    </div>
</template>

<script>
    import topImg from "../pages/indexPages/topImg.vue"
    import onlyContent from "../common/onlyContent.vue"

    export default {
        name: "toTo",
        components:{topImg,onlyContent},
        data(){
            return{
                imgHeight:"117px",
                background:"transparent"
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
    .toToBox{
        width:100%;
        height:100%;
        /*overflow-y: auto;*/
    }
</style>
